import Link from "@gik/core/components/Link.tsx";
import type WordpressSituation from "@gik/core/models/wordpress/WordpressSituation";
import routes from "@gik/core/routes";
import type { UIComponent } from "@gik/core/types/UI";
import { useBemCN } from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { SamplePagesGridWithData } from "@gik/marketing/components/SamplePages/SamplePagesGridWithData";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";
import { useTranslation } from "react-i18next";
import { translationKeys } from "./i18n/en";

export type ISamplePagesSectionProps = {
	items?: WordpressSituation[];
} & UIComponent;

function HowItWorksSamplePagesSectionComp({
	className,
	items,
}: ISamplePagesSectionProps): React.ReactElement {
	const bem = useBemCN("how-it-works-sample-pages-section");
	const { t } = useTranslation();

	return (
		<PageSection {...bem(null, null, className)} id="sample-pages">
			<h2 {...bem("title")}>{t(translationKeys.samplePagesTitle)}</h2>
			<SamplePagesGridWithData skeletonItems={5} perPage={5} items={items} />
			<Link
				href={routes.tipsAndSamplePages + "#sample-pages"}
				className="tw-text-primary-500"
			>
				<div {...bem("see-more")}>{t(translationKeys.seeMoreLink)}</div>
			</Link>
		</PageSection>
	);
}

export const HowItWorksSamplePagesSection = withComponentErrorBoundary(
	HowItWorksSamplePagesSectionComp,
);
